module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "videoSlider"
  }, [(_vm.currentSlide > 0) ? _c('button', {
    staticClass: "switchbutton",
    on: {
      "click": _vm.setPrev
    }
  }, [_vm._v("<")]) : _vm._e(), _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "video"
    }, [(_vm.currentSlide === index) ? _c('div', {
      staticClass: "currentVideo",
      domProps: {
        "innerHTML": _vm._s(item.video)
      }
    }) : _vm._e()])
  }), (_vm.currentSlide + 1 < _vm.items.length) ? _c('button', {
    staticClass: "switchbutton rightbutton",
    on: {
      "click": _vm.setNext
    }
  }, [_vm._v(">")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-974ca23e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/info/components/block/components/slider/Slider.vue
// module id = a3af91f90f39a5406752
// module chunks = 89